import { ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { compareExtras } from '@features/spa/utils/compareExtras';

export const adaptExtras = (extras) => {
  const allOptions = extras.map((e) => e.options);
  return ([] as ConfigurationGroupOptionType[]).concat(...allOptions).sort(compareExtras);
};
